import { AUTH_SET_USER, AUTH_LOGOUT } from "../action/types";

const initialState = {
  user: null,
  loading: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case AUTH_SET_USER:
      return {
        ...state,
        user: payload,
        loading: false,
        error: null,
      };

    case AUTH_LOGOUT:
      return {
        ...state,
        user: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default authReducer;
